import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    header: {
        margin: '30px 0px 50px 10px'
    },
}));

export default useStyles;